import { useState } from 'react';
import { testimonials } from '@/mocks/testimonials';

export default function TestimonialsSection() {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
              <strong className="text-primary-500">aqdlt</strong> 用户真实评价
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
              听听来自不同行业的企业用户如何评价 aqdlt 平台
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {testimonials.map((t, idx) => (
              <div
                key={t.id}
                className={`p-6 rounded-lg transition-all duration-300 cursor-pointer ${
                  idx === activeIndex
                    ? 'bg-background-50 ring-1 ring-primary-200'
                    : 'bg-background-50 hover:bg-background-50'
                }`}
                onClick={() => setActiveIndex(idx)}
              >
                <div className="flex items-center gap-3 mb-4">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="w-12 h-12 rounded-full object-cover"
                    title={t.name}
                  />
                  <div>
                    <div className="text-sm font-semibold text-foreground-900">{t.name}</div>
                    <div className="text-xs text-foreground-500">
                      {t.title} · {t.company}
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-1 mb-3">
                  {Array.from({ length: t.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm text-amber-400"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed line-clamp-4">{t.content}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}